import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import MyBottomNavigation from "../component/MyBottomNavigation";
import { Box, Typography, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Button } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import PublishIcon from '@mui/icons-material/Publish';
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { getPointApi, getPointHistroyApi, getRecoveryHistoryApi } from "../services/api/api";
import { PointHistoryInfo } from "../types/type";
import ReactCardFlip from 'react-card-flip';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useTranslation } from "react-i18next";

function Wallet(): JSX.Element {
  const { t } = useTranslation();
  const [cookies, setCookie, removeCookie] = useCookies(['recotech_mapapps_token']);
  const navigate = useNavigate();
  
  const [PointHistoryInfo, setPointHistoryInfo] = useState<PointHistoryInfo | null>(null);
  const [point, setPoint] = useState<number>(0);
  const [pointExpir, setPointExpir] = useState<Date | null>(null);
  const [amount, setAmount] = useState<number>(0);
  const [emission, setEmission] = useState<number>(0);
  const [myPlaceAmount, setMyPlaceAmount] = useState<number>(0);
  const [myPlaceEmission, setMyPlaceEmission] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlipCardClick = () => {
    setIsFlipped(!isFlipped);
  };

  //api情報を読み込みセットする
  const fetchData = async (page: number) => {
    if (!cookies.recotech_mapapps_token) navigate("/");
    if(cookies.recotech_mapapps_token){
      const PointHistoryInfoInfo = await getPointHistroyApi(page, cookies.recotech_mapapps_token, removeCookie);
      if(PointHistoryInfoInfo) setPointHistoryInfo(PointHistoryInfoInfo)
    
      const pointInfo = await getPointApi(cookies.recotech_mapapps_token,removeCookie);
      if(pointInfo){
        setPoint(pointInfo.amount)
        setPointExpir(pointInfo.expires_on)
      }
      
      const recoveryHistoryInfo = await getRecoveryHistoryApi(cookies.recotech_mapapps_token,removeCookie);
      if(recoveryHistoryInfo) {
        setAmount(recoveryHistoryInfo.total_amount_sum)
        setEmission(recoveryHistoryInfo.reduction_carbon_emission_sum)
        setMyPlaceAmount(recoveryHistoryInfo.my_recovery_place_total_amount_sum)
        setMyPlaceEmission(recoveryHistoryInfo.my_recovery_place_reduction_carbon_emission_sum)
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData(currentPage);
  }, [currentPage]);
  
  return (
    <>
      <Header/>
      <Box
        sx={{ p: 3 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >        
        <Box style={{ width: "100%"}}>
          <ReactCardFlip
            isFlipped={isFlipped}
            flipDirection="vertical"
          >          
            {/* Sub Content: CO₂削減量の表示 と リサイクル貢献量の表示 */}
            <Box 
              sx={{ mt: 2, display: "flex", justifyContent: "space-between", width: "100%" , mb:0.7}}
              onClick={handleFlipCardClick}
            >
              {/* CO₂削減量の表示 */}
              <Card sx={{ flex: 1, marginRight: 1 }}>
                <CardContent>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.soFar")}
                  </Typography>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.co2Reduction")}
                  </Typography>
                  <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography component="div" variant="h6">
                    {emission}
                  </Typography>
                  <Typography component="div" variant="caption" sx={{ml:1}}>
                    {t("pages.wallet.co2Unit")}
                  </Typography>
                </Box>
                </CardContent>
              </Card>

              {/* リサイクル貢献量の表示 */}
              <Card sx={{ flex: 1, marginLeft: 1 }}>
                <CardContent>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.soFar")}
                  </Typography>  
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.recycleContribution")}
                  </Typography>
                  <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography component="div" variant="h6">
                    {amount}
                  </Typography>
                  <Typography component="div" variant="caption" sx={{ml:1}}>
                    {t("pages.wallet.kgUnit")}
                  </Typography>
                </Box>
                </CardContent>
              </Card>
            </Box>
            {/* Sub Content: CO₂削減量の表示 と リサイクル貢献量の表示 */}
            <Box 
              sx={{ mt: 2, display: "flex", justifyContent: "space-between", width: "100%" }}
              onClick={handleFlipCardClick}
            >
              {/* CO₂削減量の表示 */}
              <Card sx={{ flex: 1, marginRight: 1, borderStyle: 'solid', borderColor: 'rgb(75, 239, 16)', borderWidth: 3}}>
                <CardContent>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.myCollectionPoint")}
                  </Typography>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.co2Reduction")}
                  </Typography>
                  <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography component="div" variant="h6">
                    {myPlaceEmission}
                  </Typography>
                  <Typography component="div" variant="caption" sx={{ml:1}}>
                    {t("pages.wallet.co2Unit")}
                  </Typography>
                </Box>
                </CardContent>
              </Card>

              {/* リサイクル貢献量の表示 */}
              <Card sx={{ flex: 1, marginLeft: 1, borderStyle: 'solid', borderColor: 'rgb(75, 239, 16)', borderWidth: 3}}>
                <CardContent>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.myCollectionPoint")}
                  </Typography>
                  <Typography component="div" variant="caption">
                    {t("pages.wallet.recycleContribution")}
                  </Typography>
                  <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography component="div" variant="h6">
                    {myPlaceAmount}
                  </Typography>
                  <Typography component="div" variant="caption" sx={{ml:1}}>
                    {t("pages.wallet.kgUnit")}
                  </Typography>
                </Box>
                </CardContent>
              </Card>
            </Box>
          </ReactCardFlip>
        </Box>
        <Typography component="div" variant="caption">
          {isFlipped
            ? t("pages.wallet.cardInstruction1")
            : t("pages.wallet.cardInstruction2")}
        </Typography>

        {/* Sub Content 3: リサイクル活動履歴 (List表示) */}
        <Box sx={{ mt: 2, width: "100%" , p:1}}>
          <Typography component="div" variant="caption">
            {t("pages.wallet.activityHistory")}
          </Typography>
          <List>
            {
              PointHistoryInfo?.histories.map((point_history,index)=>{
                return (
                  <>
                  {
                    point_history.history_type === "get"?
                    <ListItem>
                    <Box>
                      <ListItemIcon>
                        <VolunteerActivismIcon />
                      </ListItemIcon>
                    </Box>
                    <ListItemText
                      primary={point_history.note?.recovery_place_name}
                      secondary={
                        <>
                          <Typography component="div" variant="body2">
                            {point_history.note?.description}
                          </Typography>
                          <Typography component="div" variant="caption">
                            {new Date(point_history.executed_at).toLocaleDateString("ja-JP", {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit'
                            }).replace(/\//g, '-').replace(/ /g, ' ')}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>:null
                  }
                  </>
                )
              })
            }
          </List>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
            }}
          >
            {PointHistoryInfo?.current_page! > 1 && (
              <Button
                sx={{ mr: 2 }}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                {t("pages.wallet.prev")}
              </Button>
            )}
            {PointHistoryInfo?.next_page && (
              <Button onClick={() => setCurrentPage(currentPage + 1)}
              >
                {t("pages.wallet.next")}
              </Button>
            )}
          </Box>
        </Box>


      </Box>
      <Box sx={{height: "100px"}}/>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        width="100%"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <MyBottomNavigation />
      </Box>
    </>
  );
}

export default Wallet;
